export default __webpack_public_path__ + "static/media/score.c856d908.svg";